document.addEventListener("DOMContentLoaded", () => {
  let headerClone = null;
  const MOBILE_BREAKPOINT = 699;
  const MIN_SPACING = 40;
  let headerHeight = 0;
  const header = document.querySelector("header.new-header");
  const headerNotClone = document.querySelector(
    "header.new-header:not(.header-clone)"
  );
  const headerDrawer = document.querySelector(".header-drawer");
  const headerDrawerNav = headerDrawer.querySelector(".header-drawer__nav");
  const headerDrawerBtns = headerDrawer.querySelector(".header-drawer__btns");
  const headerDrawerIcon = document.querySelector("[data-drawer-icon]");

  // Megamenu functionality
  const megamenuTriggers = document.querySelectorAll("[data-megamenu-trigger]");
  const megamenus = document.querySelectorAll("[data-megamenu]");
  let activeMegamenu = null;
  let hideTimeoutId = null;

  function isMobileView() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function isInDrawer(element) {
    return element.closest(".header-drawer") !== null;
  }

  function getTriggerLink(megamenu) {
    const trigger = megamenu.closest("[data-megamenu-trigger]");
    return trigger ? trigger.querySelector("a") : null;
  }

  function initializeMegamenu() {
    megamenuTriggers.forEach(trigger => {
      const megamenu = trigger.querySelector("[data-megamenu]");
      const link = trigger.querySelector("a");
      
      if (!megamenu || !link) return;

      trigger.addEventListener("mouseenter", () => {
        if (isMobileView() || isInDrawer(trigger)) return;
        if (hideTimeoutId) {
          clearTimeout(hideTimeoutId);
          hideTimeoutId = null;
        }
        hideAllMegamenus();
        showMegamenu(megamenu);
      });

      trigger.addEventListener("mouseleave", () => {
        if (isMobileView() || isInDrawer(trigger)) return;
        hideTimeoutId = setTimeout(() => {
          hideMegamenu(megamenu);
          hideTimeoutId = null;
        }, 120);
      });

      link.addEventListener("click", (e) => {
        const isDrawer = megamenu.classList.contains("header-drawer__megamenu");
        if (!isDrawer) return;
        e.preventDefault();
        
        if (activeMegamenu === megamenu && megamenu.classList.contains("active")) {
          hideMegamenu(megamenu);
        } else {
          hideAllMegamenus();
          showMegamenu(megamenu);
        }
      });

      link.addEventListener("touchstart", (e) => {
        e.stopPropagation();
      }, { passive: true });

      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          if (isMobileView() || isInDrawer(trigger)) return;
          e.preventDefault();
          if (megamenu.classList.contains("active")) {
            hideMegamenu(megamenu);
          } else {
            hideAllMegamenus();
            showMegamenu(megamenu);
          }
        }
      });
    });

    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-megamenu-trigger]")) {
        hideAllMegamenus();
      }
    });

    document.addEventListener("touchstart", (e) => {
      if (!e.target.closest("[data-megamenu-trigger]")) {
        hideAllMegamenus();
      }
    }, { passive: true });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        hideAllMegamenus();
      }
    });
  }

  function showMegamenu(megamenu) {
    
    if (activeMegamenu && activeMegamenu !== megamenu) {
      hideMegamenu(activeMegamenu);
    }
    
    megamenu.classList.add("active");

    const triggerLink = getTriggerLink(megamenu);
    if (triggerLink) {
      triggerLink.classList.add("megamenu-open");
    }

    if (megamenu.classList.contains("new-header__megamenu")) {
      megamenu.style.opacity = "1";
      megamenu.style.visibility = "visible";  
      megamenu.style.marginTop = "0";
    }
    
    // Handle mobile megamenu
    if (megamenu.classList.contains("header-drawer__megamenu")) {
      megamenu.style.maxHeight = "500px";
    }
    
    activeMegamenu = megamenu;
  }

  function hideMegamenu(megamenu) {

    megamenu.classList.remove("active");

    const triggerLink = getTriggerLink(megamenu);
    if (triggerLink) {
      triggerLink.classList.remove("megamenu-open");
    }

    if (megamenu.classList.contains("new-header__megamenu")) {
      megamenu.style.opacity = "0";
      megamenu.style.visibility = "hidden";
      megamenu.style.marginTop = "10px";
    }
    
    if (megamenu.classList.contains("header-drawer__megamenu")) {
      megamenu.style.maxHeight = "0";
    }
    
    if (activeMegamenu === megamenu) {
      activeMegamenu = null;
    }
  }

  function hideAllMegamenus() {
    megamenus.forEach(megamenu => {
      hideMegamenu(megamenu);
    });
  }

  function createHeaderClone() {
    if (!header) return null;
    const clone = header.cloneNode(true);
    clone.classList.remove("--mobile");
    clone.classList.add("header-clone");

    clone.style.cssText = `
        position: absolute !important;
        top: -9999px !important;
        left: -9999px !important;
        visibility: hidden !important;
        pointer-events: none !important;
        width: ${header.offsetWidth}px !important;
      `;

    document.body.appendChild(clone);
    return clone;
  }

  function checkHeaderHeight() {
    if (headerNotClone && headerDrawer) {
      headerHeight = headerNotClone.offsetHeight;
      headerDrawer.style.setProperty("--header-height", `${headerHeight}px`);
    }
  }

  function checkWidth() {
    if (!headerNotClone) return;

    // Mobile viewport check
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      headerNotClone.classList.add("--mobile");
      return;
    }

    // Create clone if needed for desktop measurements
    if (!headerClone) {
      headerClone = createHeaderClone();
    }

    if (!headerClone) {
      headerNotClone.classList.remove("--mobile");
      return;
    }

    // Update clone width and measure navigation fit
    headerClone.style.width = `${headerNotClone.offsetWidth}px`;

    const cloneNav = headerClone.querySelector(".new-header__nav");
    const cloneNavList = headerClone.querySelector(".new-header__nav-list");

    if (cloneNav && cloneNavList) {
      const hasInsufficientSpace =
        cloneNav.offsetWidth - cloneNavList.offsetWidth < MIN_SPACING && window.innerWidth <= 1023;
      headerNotClone.classList.toggle("--mobile", hasInsufficientSpace);
    }
  }

  function checkNavListHeight() {
    let headerDrawerBtnsHeight = headerDrawerBtns.offsetHeight + 25;

    headerDrawerNav.style.setProperty(
      "--max-height",
      `calc(100svh - ${headerHeight}px - ${headerDrawerBtnsHeight}px)`
    );

    headerDrawerNav.scrollHeight > 0
      ? headerDrawerNav.classList.add("scroll-shadow")
      : headerDrawerNav.classList.remove("scroll-shadow");
  }

  function toggleDrawer() {
    headerDrawer.classList.toggle("active");
    headerDrawerIcon.classList.toggle("active");
    if (headerDrawer.classList.contains("active")) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      hideAllMegamenus();
    }
  }

  const debouncedCheckWidth = debounce(checkWidth, 250);
  const debouncedCheckHeaderHeight = debounce(checkHeaderHeight, 250);
  const debouncedCheckNavListHeight = debounce(checkNavListHeight, 250);

  // Close drawer on outside click
  document.addEventListener("click", (e) => {
    if (!headerDrawer.classList.contains("active")) return;
    
    const isOutsideDrawer = !e.target.closest(".header-drawer");
    const isNotDrawerTrigger = !e.target.closest("[data-drawer-icon]");
    
    if (isOutsideDrawer && isNotDrawerTrigger) {
      toggleDrawer();
    }
  });

  // Initialize
  checkWidth();
  checkHeaderHeight();
  checkNavListHeight();
  initializeMegamenu();
  headerDrawerIcon.addEventListener("click", toggleDrawer);

  window.addEventListener("resize", () => {
    debouncedCheckWidth();
    debouncedCheckHeaderHeight();
    debouncedCheckNavListHeight();
  });
});